import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { CheckboxGroupControlled } from './CheckboxGroupControlled';
import { CheckboxGroupUncontrolled } from './CheckboxGroupUncontrolled';
export const CheckboxGroup = (props) => {
    if (props.value !== undefined) {
        return _jsx(CheckboxGroupControlled, Object.assign({}, props));
    }
    return _jsx(CheckboxGroupUncontrolled, Object.assign({}, props));
};
